export const SWITCHES_KEY = '_switches';
export type FILTERSTATE_SWITCHES_KEY = typeof SWITCHES_KEY;

export class FilterState<T> {
  private _map: Record<string, boolean> = {};

  public key: keyof T | FILTERSTATE_SWITCHES_KEY;
  public title: string;
  public items: string[] | (keyof T)[];

  public get hasItems() {
    return this.items && this.items.length > 0;
  }

  public getMapSnapshot(state?: boolean) {
    let entries = Object.entries(this._map);
    if (state !== undefined) {
      entries = entries.filter(kvp => kvp[1] === false);
    }
    return Object.fromEntries(entries);
  }

  public setMapSnapshot(obj: Record<string, boolean>) {
    this._map = {
      ...this._map,
      ...obj,
    };
  }

  public constructor(key: keyof T | FILTERSTATE_SWITCHES_KEY, title: string, items: string[] | (keyof T)[]) {
    this.key = key;
    this.title = title;
    this.items = items;
    this.items.forEach(x => this._init(x as string));
  }

  private _init(item: string) {
    if (!(item in this._map)) {
      this._map[item] = true;
    }
  }

  public toggle(value: string, state?: boolean) {
    this._init(value);
    this._map[value] = state ?? !this._map[value];
  }

  public get(item: string) {
    this._init(item);
    return this._map[item];
  }

  public toggleAll(state: string | boolean) {
    Object.keys(this._map).forEach(key => (this._map[key] = state as boolean));
  }

  public getItemsInState(state: boolean) {
    return Object.keys(this._map).filter(key => this._map[key] === state);
  }

  public isAll() {
    return Object.keys(this._map).every(key => this._map[key] === true);
  }

  public isNone() {
    return Object.keys(this._map).every(key => !this._map[key]);
  }
}
